import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { AdminSideBar } from "@/components";
import { WhiteContainer } from "@/styling/baseStyle";
import { PlayersList } from "./Players";
import { CoachList } from "./Coaches";
import { AdminProspectList } from "./Prospects";
import { withRouter } from "react-router";
import { AdminsList } from "./Admins";
import { EditorsList } from "./Editors";
import { AssistantsList } from "./Assitants";
import { Tabs } from "@/components/ui";

type Props = RouteComponentProps;

const UsersPageFC: React.FC<Props> = ({ history }) => {
  return (
    <WhiteContainer>
      <AdminSideBar history={history} />
      <div className="hugePadding adminUserTabs flex-1 w-full min-w-0">
        <Tabs defaultValue="coaches" className="w-full">
          <Tabs.List variant="menu" className="mb-4">
            <Tabs.Trigger value="coaches" className="text-sm font-semibold">
              Coaches
            </Tabs.Trigger>
            <Tabs.Trigger value="players" className="text-sm font-semibold">
              Players
            </Tabs.Trigger>
            <Tabs.Trigger value="assistants" className="text-sm font-semibold">
              Assistants
            </Tabs.Trigger>
            <Tabs.Trigger value="prospects" className="text-sm font-semibold">
              Prospects
            </Tabs.Trigger>
            <Tabs.Trigger value="admins" className="text-sm font-semibold">
              Admins
            </Tabs.Trigger>
            <Tabs.Trigger value="editors" className="text-sm font-semibold">
              Editors
            </Tabs.Trigger>
          </Tabs.List>

          <Tabs.Content value="coaches">
            <div className="pt-2">
              <CoachList />
            </div>
          </Tabs.Content>

          <Tabs.Content value="players">
            <div className="pt-2">
              <PlayersList />
            </div>
          </Tabs.Content>

          <Tabs.Content value="assistants">
            <div className="pt-2">
              <AssistantsList />
            </div>
          </Tabs.Content>

          <Tabs.Content value="prospects">
            <div className="pt-2">
              <AdminProspectList />
            </div>
          </Tabs.Content>

          <Tabs.Content value="admins">
            <div className="pt-2">
              <AdminsList />
            </div>
          </Tabs.Content>

          <Tabs.Content value="editors">
            <div className="pt-2">
              <EditorsList />
            </div>
          </Tabs.Content>
        </Tabs>
      </div>
    </WhiteContainer>
  );
};

export const UsersPage = withRouter(UsersPageFC);
